import { IClientVarsService } from '../interfaces/client-vars-service.interface';
import { IClientVars } from '../interfaces/client-vars.interface';
import { IDocInfo, IDocInfoManager } from '../interfaces/doc-info.interface';
import { IEditEvents } from '../interfaces/event.interface';
import { ILogger } from '../slide-data-services.core';

export abstract class DocInfoBaseManager implements IDocInfoManager {
    public docInfo: IDocInfo = {};
    public visible = true;
    protected clientVars: IClientVars = {};
    protected getDocInfoPromise: Promise<IDocInfo>;
    private ready = false;

    public constructor(
        protected logger: ILogger,
        protected editEvent: IEditEvents,
        protected clientVarsService: IClientVarsService,
    ) {
        this.clientVars = this.clientVarsService.getClientVars();
        this.getDocInfoPromise = this.getDocInfo().then((docInfo = {}) => {
            this.docInfo = docInfo;
            this.ready = true;
            return docInfo;
        });
    }

    public waitForReady(callback: (docInfo: IDocInfo) => void) {
        if (this.ready) {
            callback(this.docInfo);
            return;
        }
        this.getDocInfoPromise.then(callback);
    }

    public waitForReadyPromise() {
        return this.getDocInfoPromise;
    }

    public get title() {
        return this.clientVars.title;
    }

    public get globalPadId() {
        return this.clientVars.globalPadId;
    }

    public get cGlobalPadId() {
        return this.clientVars.cGlobalPadId;
    }

    public get padId() {
        return this.clientVars.padId;
    }

    public get cPadId() {
        return this.cGlobalPadId?.split('$')?.[1];
    }

    public get localPadId() {
        return this.clientVars.localPadId;
    }

    public get cLocalPadId() {
        return this.localPadId?.split('$')?.[1];
    }

    public get domainId() {
        return this.clientVars.domainId;
    }

    public get tinyid() {
        return this.clientVars.tinyid || this.userInfo?.tinyid;
    }

    public get subId() {
        return this.clientVars.subId;
    }

    public get userId() {
        return this.clientVars.userId;
    }

    public get ownerId() {
        return this.clientVars.ownerId;
    }

    public get userInfo() {
        return this.clientVars.userInfo;
    }

    public get creatorDomain() {
        return this.clientVars.creatorDomain;
    }

    public get pVer() {
        return this.clientVars.collab_client_vars?.pver;
    }

    public get baseRevision() {
        return this.clientVars.collab_client_vars?.rev;
    }

    public get gray() {
        return this.clientVars.collab_client_vars?.gray;
    }

    public get dirty() {
        return this.clientVars.collab_client_vars?.dirty;
    }

    public get policy() {
        return this.clientVars.policy;
    }

    public get padType() {
        return this.clientVars.padType;
    }

    public get isUserChangeTitle() {
        return this.clientVars.isUserChangeTitle;
    }

    // public get visible() {
    //     return this.docInfo.is;
    // }

    public get collected() {
        return !!this.docInfo.is_collected;
    }

    public setCollected(value: boolean) {
        this.docInfo.is_collected = Number(value);
    }

    public get extra() {
        return {
            ownerNick: this.docInfo?.owner_nick,
            creatorNick: this.docInfo?.creator_nick,
            docURL: this.docInfo?.doc_url,
            ownerUidSource: this.docInfo?.owner_uid_source,
        };
    }

    public get isAddedMyDoc() {
        return this.docInfo.is_added_my;
    }

    public get isOwner() {
        return this.clientVars.isOwner;
    }

    public get isCreator() {
        return this.clientVars.isCreator;
    }

    public get isDeleted() {
        return this.clientVars.isDeleted || this.clientVars.cgicode === 200405;
    }

    public get rightFlag() {
        return this.clientVars.rightFlag;
    }

    public get docStatus() {
        return this.clientVars.docStatus;
    }

    public get fileInfo() {
        return this.clientVars.fileInfo;
    }

    public abstract setDocVisible(): Promise<void>;
    protected abstract getDocInfo(): Promise<IDocInfo>;
}
